module.exports = __webpack_public_path__ + "img/List_Skills1.ec35cd6b.png";